<template>
  <div>
      <user-info
          :userInformationUrl="userInformationUrl"
          :revokeUserUrl="revokeUserUrl"
          :restoreUserUrl="restoreUserUrl"
          :updateUserPermissionsUrl="updateUserPermissionsUrl">
      </user-info>
  </div>
</template>
<script>
  import Vue from 'vue'
  import UserInfo from '@/components/misc/user-info/UserInfo'

  export default {
    name: 'local-user-information',
    components: {
      UserInfo
    },
    data () {
      return {
        userInformationUrl: '',
        updateUserPermissionsUrl: '',
        revokeUserUrl: '',
        restoreUserUrl: '',
        userId: this.$route.params.userId
      }
    },
    created () {
      this.userInformationUrl = Vue.$apiConfig.localUserInformationGet
      this.updateUserPermissionsUrl = Vue.$apiConfig.updateLocalUserPermissionsPost
      this.revokeUserUrl = Vue.$apiConfig.userRevokePost
      this.restoreUserUrl = Vue.$apiConfig.userRestorePost
    }
  }
</script>



// WEBPACK FOOTER //
// LocalUserInformation.vue?71b74017